export const PERMISSIONS = {
    CAN_PLACE_NEW_CAR_ORDER: "Can_Place_New_Car_Order",
    CAN_VIEW_CAR_ORDERS: "Can_View_Car_Orders",
    CAN_CREATE_BILLS: "Can_Create_Bills",
    CAN_VIEW_CHARGE_MANAGEMENT: "Can_View_Charge_Management",
    CAN_VIEW_ASSIGNED_EQUIPMENT_CAR_ORDERS:
        "Can_view_assigned_equipment_car_orders",
    CAN_VIEW_GENERAL_REQUEST: "Can_View_General_Request",
    CAN_PLACE_GENERAL_REQUEST: "Can_Place_General_Request",
    CAN_MANAGE_EMAIL_NOTIFICATIONS: "Can_manage_email_notifications",
    CAN_MOVE_CARS: "Can_Move_Cars",
    CAN_SUBMIT_SWITCH_REQUST: "Can_Submit_Switch_Request",
    CAN_VIEW_ENHANCED_VISIBILITY_DATA: "can_view_enhanced_visibility_data",
    CAN_ACCESS_FORCASTING_MODULE: "can_access_forecasting_module",
    CAN_MANAGE_FORECASTING_PLANS: "can_manage_forecasting_plans",
    CAN_ACCESS_ENHANCED_VISIBILITY_MODULE: "can_access_enhanced_visibility_module",
}
